import { render } from "./LicenseReminder.vue?vue&type=template&id=5c39f67a&scoped=true"
import script from "./LicenseReminder.vue?vue&type=script&lang=js"
export * from "./LicenseReminder.vue?vue&type=script&lang=js"

import "./LicenseReminder.vue?vue&type=style&index=0&id=5c39f67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c39f67a"]])

export default __exports__